// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styleModule_bannerContainer__9Yb41","bannerImage":"styleModule_bannerImage__qt5at"};